<template>
    <div>
        <b-modal ref="addDeduction" hide-footer title="Dodaj" @hidden="onDeductionModalHidden" @shown="setupModalData">
            <alert-loading v-if="debtorFormLoading"></alert-loading>
            <form-deduction
                    v-if="!debtorFormLoading"
                    ref="addDeductionForm"
                    :currencyName="currencyName"
                    :handleSubmit="handleDeductionSubmit"
                    :values="deductionData"
                    :errors="deductionViolations"
                    :typeSelection="typeSelection"
                    :amountFromTransfer="amountFromTransfer"
            ></form-deduction>
            <b-row v-if="!debtorFormLoading">
                <b-col>
                    <b-button class="mt-3" variant="primary" block @click="hideDeductionModal">
                        <span>Anuluj</span>
                        <svg-icon name="back"/>
                    </b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="default" block @click="sendDeductionForm">
                        <span>Zapisz</span>
                        <svg-icon name="tick"/>
                    </b-button>
                </b-col>
            </b-row>
        </b-modal>
        <div v-if="createdDeductionMessage" class="alert alert-success">Potrącenie w kwocie {{createdDeductionMessage}} zostało dodane</div>
        <div v-if="deleteDeductionMessage" class="alert alert-success">Potrącenie w kwocie {{deleteDeductionMessage}} zostało usunięte</div>
        <alert-loading v-if="deductionListLoading || deductionDeleteLoading"></alert-loading>
        <b-row v-if="!deductionListLoading && !deductionDeleteLoading" align-h="start">
            <b-col>
                <b-button variant="default" @click.prevent="showDeductionModal('advance-deduction')">
                    <span>Dodaj zaliczkę/potrącenie</span>
                    <svg-icon name="plus"/>
                </b-button>
                <b-button variant="default" @click.prevent="showDeductionModal('refund')">
                <span>Dodaj zwrot</span>
                <svg-icon name="plus"/>
                </b-button>
            </b-col>
        </b-row>
        <div v-if="!deductionListLoading && !deductionDeleteLoading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Opis</th>
                    <th>Uwagi</th>
                    <th>Kwota ({{currencyName}})</th>
                    <th v-if="!amountFromTransfer">Rozliczenie</th>
                    <th>Data</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in deductionListItems">
                    <td class="td-no_link">{{item.description}}</td>
                    <td class="td-no_link">{{item.comments}}</td>
                    <td class="td-no_link">{{item.amount}}</td>
                    <td v-if="!amountFromTransfer" class="td-no_link">{{item.settlementType|translate}}</td>
                    <td class="td-no_link no-wrap">{{item.deductionDate | date}}</td>
                    <td class="td-no_link">
                        <a href="#" class="btn btn-icon btn-icon--warning" v-b-tooltip.hover.bottom title="Usuń" @click.prevent="deleteDeduction(item)">
                            <svg-icon name="minus"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import FormDeduction from './FormDeduction.vue'

  export default {
    components: {
      'form-deduction': FormDeduction
    },
    mounted () {
      this.getDeductionList(this.retrieved.id);
    },
    data: function () {
      return {
        item: {},
        errors: {},
        deductionData: {},
        createdDeductionMessage: null,
        deleteDeductionMessage: null,
        typeSelection: 'advance-deduction',
      }
    },
    computed: {
      debtorFormLoading () {
        return this.deductionLoading
      },
      currencyName () {
        if (this.retrieved != null) {
          return this.retrieved.currency.name
        }
        else {
          return '...'
        }
      },
      amountFromTransfer(){
        if (this.retrieved != null) {
              return this.retrieved.currency.foreign == false
        }
        else {
          return false
        }
      },
      ...mapGetters({
        retrieved: 'agreement/update/retrieved',
        deductionTypes: 'config/config/deductionTypes',
        deductionCreated: 'deduction/create/created',
        deductionViolations: 'deduction/create/violations',
        deductionLoading: 'deduction/create/loading',
        deductionListItems: 'deduction/list/items',
        deductionListLoading: 'deduction/list/loading',
        deductionDeleted: 'deduction/del/deleted',
        deductionDeleteLoading: 'deduction/del/loading',
      })
    },
    methods: {
      deleteDeduction(deduction){
        if (window.confirm('Czy na pewno chce usunąć ten element?')) {
          this.$store.dispatch('deduction/del/delete', deduction)
        }
      },
      onDeductionModalHidden(){
        this.$refs.addDeductionForm.resetFormData()
      },
      setupModalData(){
        this.$refs.addDeductionForm.setupFormData()
      },
      showDeductionModal (type) {
        this.$store.dispatch('deduction/create/reset')
        this.typeSelection = type;
        this.deductionData = {
          deductionType: undefined,
          transferType: undefined,
          factoredInvoice: undefined,
          deductionDate: new Date()
        };

        this.$refs.addDeduction.show()
      },
      sendDeductionForm () {
        this.$refs.addDeductionForm.sendForm()
      },
      handleDeductionSubmit (deduction) {
        deduction.agreement = this.retrieved['@id']
        this.$store.dispatch('deduction/create/create', deduction)
      },
      hideDeductionModal () {
        this.$refs.addDeduction.hide()
      },
      ...mapActions({
        getDeductionList: 'deduction/list/getItems'
      })
    },
    watch: {
      deductionDeleted: function (deduction) {
        if (deduction != null) {
          this.hideDeductionModal();
          this.deleteDeductionMessage = deduction.amount
          setTimeout(() => {
            this.deleteDeductionMessage = null
          }, 5000)
          this.getDeductionList(this.retrieved.id)
        }
      },
      deductionCreated: function (deduction) {
        if (deduction != null) {
          this.hideDeductionModal();
          this.createdDeductionMessage = deduction.amount
          setTimeout(() => {
            this.createdDeductionMessage = null
          }, 5000)
          this.getDeductionList(this.retrieved.id)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UpdateDeduction.vue?4adfa272